import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "panelDate", "monthLabel", "onSelected"];
import React from 'react';
import { noop } from '@uiw/utils';
import "./style/year-month.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function DatePickerMonth(props) {
  var {
      prefixCls = 'w-datepicker',
      className,
      panelDate = new Date(),
      monthLabel,
      onSelected = noop
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", _extends({
    className: [prefixCls ? prefixCls + "-month" : null, className].filter(Boolean).join(' ').trim()
  }, other, {
    children: [...Array(12)].map((_, idx) => {
      var selectedMonth = panelDate.getMonth();
      return /*#__PURE__*/_jsx("div", {
        className: [selectedMonth === idx ? 'selected' : null].filter(Boolean).join(' ').trim(),
        children: /*#__PURE__*/_jsx("span", {
          onClick: () => onSelected(idx, false),
          children: monthLabel && monthLabel[idx] || idx
        })
      }, idx);
    })
  }));
}